import { safeLocalStorage } from 'wsm-tagging-utils';
import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import formatCAIWallet from './formatCAIWallet';

const injectCAIWalletConfig = (win, form) => {
	const mywallet = win?.DDC?.checkCAIWalletConfig?.();

	if (mywallet) {
		const walletConfigKey = 'CAIWalletConfig';

		const data = safeLocalStorage.getItem(walletConfigKey, win) || '{}';
		const walletData = JSON.parse(data);

		createOrUpdateHiddenField(
			form,
			`_custom=CAI_WALLET_CONFIG=-1=${walletConfigKey}`,
			formatCAIWallet(walletData)
		);
	}
};

export default injectCAIWalletConfig;
